import { AD_STATES, GOALS } from "components/core/blocks/AdPlan/constants";
import moment from "moment";

interface Ad {
  created_datetime: string;
  serving_hours: number;
  ad_sales_percent: number;
  ad_sales_delta: number;
  ad_sales: number;
  max_acos: number;
  target_acos: number;
  state: number;
  acos: number;
  ad_goal: number;
  non_trellis_enrolled_ad: boolean;
}

interface AdGroups {
  all: Ad[];
  recent: Ad[];
  serving_low: Ad[];
  trend_up: Ad[];
  trend_down: Ad[];
  high_acos: Ad[];
  low_acos: Ad[];
  in_range_acos: Ad[];
}

export const groupAdPlans = (ads: Ad[]): AdGroups => {
  const adsGroups: AdGroups = {
    all: ads,
    recent: ads.filter((ad) => moment(ad.created_datetime) >= moment().subtract(7, "days")),
    serving_low: ads.filter((ad) => ad.serving_hours < 22),
    trend_up: ads
      .filter((ad) => ad.ad_sales_percent > 0.05)
      .sort((a, b) => a.ad_sales_delta / a.ad_sales - b.ad_sales_delta / b.ad_sales),
    trend_down: ads
      .filter((ad) => ad.ad_sales_percent < -0.05)
      .sort((a, b) => b.ad_sales_delta / b.ad_sales - a.ad_sales_delta / a.ad_sales),
    high_acos: ads.filter(
      (ad) =>
        !(ad.ad_goal === GOALS.IMPORTED_ADS.value && !ad.non_trellis_enrolled_ad) &&
        ad.max_acos &&
        ad.acos > ad.max_acos / 100.0 + 0.025,
    ),
    low_acos: ads.filter(
      (ad) =>
        !(ad.ad_goal === GOALS.IMPORTED_ADS.value && !ad.non_trellis_enrolled_ad) &&
        ad.target_acos &&
        ad.state === AD_STATES.ACTIVE.value &&
        ad.acos < ad.target_acos / 100.0 - 0.025,
    ),
    in_range_acos: ads.filter(
      (ad) =>
        !(ad.ad_goal === GOALS.IMPORTED_ADS.value && !ad.non_trellis_enrolled_ad) &&
        ad.max_acos &&
        ad.target_acos &&
        ad.state === AD_STATES.ACTIVE.value &&
        ad.acos < ad.max_acos / 100.0 &&
        ad.acos > ad.target_acos / 100.0,
    ),
  };
  return adsGroups;
};
